import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const Nominee = () => {
  const [nomineeName, setNomineeName] = useState('');
  const [nomineeGender, setNomineeGender] = useState('');
  const [nomineeDob, setNomineeDob] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const applicationId = new URLSearchParams(location.search).get('applicationId');
  const customerId    = new URLSearchParams(location.search).get('customerId');

  const handleSubmit = async () => {
    if (!nomineeName || !nomineeGender || !nomineeDob) { setErrorModal(true); return; }
    setIsLoading(true);
    try {
      await api.post(
        `${base_url}/api/customer/addNomineeDetails?customerId=${customerId}&nomineeName=${encodeURIComponent(nomineeName)}&nomineeGender=${nomineeGender}&nomineeDob=${nomineeDob}`,
        null,
        { headers: { 'Content-Type': 'application/json' } }
      );
      navigate(`/Reference?applicationId=${applicationId}&customerId=${customerId}`);
    } catch {
      setErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-page">
      <TopBar title="Nominee Details" backPath={`/Employmentdetails?applicationId=${applicationId}&customerId=${customerId}`} />
      {isLoading && <div className="loader-overlay"><div className="spinner-border text-light" /></div>}

      <div className="app-content">
        <div className="app-card">
          <p className="section-title">Nominee Information</p>

          <div className="field-group">
            <label className="field-label">Nominee Name <span className="field-star">*</span></label>
            <input className="field-input" value={nomineeName} onChange={e => setNomineeName(e.target.value)} />
          </div>

          <div className="field-group">
            <label className="field-label">Gender <span className="field-star">*</span></label>
            <select className="field-select" value={nomineeGender} onChange={e => setNomineeGender(e.target.value)}>
              <option value="" hidden>Select Gender</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
              <option value="3">Other</option>
            </select>
          </div>

          <div className="field-group">
            <label className="field-label">Date of Birth <span className="field-star">*</span></label>
            <input className="field-input" type="date" value={nomineeDob} onChange={e => setNomineeDob(e.target.value)} />
          </div>
        </div>

        <button className="btn-primary-app" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Proceed'}
        </button>
      </div>

      <Modal show={errorModal} onHide={() => setErrorModal(false)} centered>
        <Modal.Body className="text-center p-4"><strong>Please fill in all required fields.</strong></Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setErrorModal(false)}>OK</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Nominee;
